import { ICellRendererParams } from "ag-grid-community"
import { Icon, Tooltip } from "@blueprintjs/core"
import { OutputTransformation } from "../types/dashboard"
import { IconWrapper, MetricContainer, MetricText } from "./MetricCellRenderer.styled"

const MetricCellRenderer = (props: ICellRendererParams) => {
  const { value, data } = props
  const transformation = data?.transformation as OutputTransformation | undefined
  const transformationApplied = data?.transformation_applied as boolean | undefined

  if (!transformation || transformation === OutputTransformation.NONE) {
    return <MetricText>{value}</MetricText>
  }

  // Transformation was requested but couldn't be applied
  // Reasons: frequency unknown, or data is already a PoP type (e.g., YoY%)
  const showWarning = transformation && !transformationApplied

  return (
    <MetricContainer>
      <MetricText>{value}</MetricText>
      <IconWrapper>
        {showWarning ? (
          <Tooltip content="Transformation could not be applied">
            <Icon icon="warning-sign" size={12} intent="warning" />
          </Tooltip>
        ) : (
          <>
            {transformation === OutputTransformation.YOY && (
              <Tooltip content="YoY">
                <Icon icon="calendar" size={12} intent="primary" />
              </Tooltip>
            )}
            {transformation === OutputTransformation.SEQ && (
              <Tooltip content="Sequential">
                <Icon icon="trending-up" size={12} intent="success" />
              </Tooltip>
            )}
            {transformation === OutputTransformation.INDEX && (
              <Tooltip content="Index">
                <Icon icon="timeline-line-chart" size={12} intent="primary" />
              </Tooltip>
            )}
          </>
        )}
      </IconWrapper>
    </MetricContainer>
  )
}

export default MetricCellRenderer
